/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CompletedImport } from './routes/completed'

// Create Virtual Routes

const SyncLazyImport = createFileRoute('/sync')()
const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const SyncLazyRoute = SyncLazyImport.update({
  path: '/sync',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/sync.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const CompletedRoute = CompletedImport.update({
  path: '/completed',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/completed': {
      id: '/completed'
      path: '/completed'
      fullPath: '/completed'
      preLoaderRoute: typeof CompletedImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/sync': {
      id: '/sync'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof SyncLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/completed': typeof CompletedRoute
  '/about': typeof AboutLazyRoute
  '/sync': typeof SyncLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/completed': typeof CompletedRoute
  '/about': typeof AboutLazyRoute
  '/sync': typeof SyncLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/completed': typeof CompletedRoute
  '/about': typeof AboutLazyRoute
  '/sync': typeof SyncLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/completed' | '/about' | '/sync'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/completed' | '/about' | '/sync'
  id: '__root__' | '/' | '/completed' | '/about' | '/sync'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  CompletedRoute: typeof CompletedRoute
  AboutLazyRoute: typeof AboutLazyRoute
  SyncLazyRoute: typeof SyncLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  CompletedRoute: CompletedRoute,
  AboutLazyRoute: AboutLazyRoute,
  SyncLazyRoute: SyncLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/completed",
        "/about",
        "/sync"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/completed": {
      "filePath": "completed.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/sync": {
      "filePath": "sync.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
